const MAX_BERITA_SLUG_LENGTH = 72;

export const slugifyBeritaTitle = (
  value,
  maxLength = MAX_BERITA_SLUG_LENGTH,
) => {
  const normalized = String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  if (!normalized) return "berita";

  const words = normalized.split(" ").filter(Boolean);
  const parts = [];
  let used = 0;

  for (const word of words) {
    const addLength = parts.length > 0 ? word.length + 1 : word.length;
    if (used + addLength > maxLength) break;
    parts.push(word);
    used += addLength;
  }

  return (parts.join("-") || "berita")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
};

export const getBeritaDetailPath = (berita, titleOverride) => {
  const title = titleOverride || berita?.judul || berita?.judul_en || "berita";
  return `/berita/${slugifyBeritaTitle(title)}`;
};

export const isLegacyBeritaIdPath = (slugOrId) =>
  /^\d+$/.test(String(slugOrId || "").trim());

export const findBeritaBySlugOrId = (items, slugOrId) => {
  const raw = decodeURIComponent(String(slugOrId || "").trim());
  if (!raw) return null;

  if (isLegacyBeritaIdPath(raw)) {
    const id = parseInt(raw, 10);
    return items.find((item) => item.id === id) || null;
  }

  return (
    items.find((item) => {
      const slugId = slugifyBeritaTitle(item.judul);
      const slugEn = slugifyBeritaTitle(item.judul_en);
      return raw === slugId || raw === slugEn;
    }) || null
  );
};
